import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {speculatorT} from '@/lib/types/speculator.types';

interface SPECULATOR_STATE {
  speculators: speculatorT[];
  isLoading?: boolean;
  error?: string | null;
}

const SPECULATOR_INITIAL: SPECULATOR_STATE = {
  speculators: [],
  isLoading: false,
  error: null,
};

const speculatorSlice = createSlice({
  name: 'speculator',
  initialState: {
    ...SPECULATOR_INITIAL,
  },
  reducers: {
    SPECULATOR_UPDATE: (
      state,
      action: PayloadAction<{data?: SPECULATOR_STATE; prop?: string; value?: string | Date}>
    ) => {
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? {[action.payload.prop]: action.payload.value} : null),
      });
    },
  },
});

const {SPECULATOR_UPDATE} = speculatorSlice.actions;

export {speculatorSlice, SPECULATOR_INITIAL, SPECULATOR_UPDATE};
